P3Portal.messages = {
    info: function (message, timeout) {
        if (!timeout) timeout = 4000;
        new Noty({
            theme: 'light',
            layout: 'top',
            type: 'information',
            text: message,
            timeout: timeout,
        }).show();
    },
};

/* jQuery Tiny Pub/Sub - v0.7 - 10/27/2011
 * http://benalman.com/
 * Copyright (c) 2011 "Cowboy" Ben Alman; Licensed MIT, GPL */

(function ($) {
    var o = $({});

    $.subscribe = function () {
        o.on.apply(o, arguments);
    };

    $.unsubscribe = function () {
        o.off.apply(o, arguments);
    };

    $.publish = function () {
        o.trigger.apply(o, arguments);
    };
})(jQuery);

// Clean a string of weird characters and then parse an int
String.prototype.clean_int = function () {
    var number = this.toString().replace(/,/g, '');
    return parseInt(number);
};
// Clean a string of weird characters and then parse a float
String.prototype.clean_float = function () {
    var number = this.toString().replace(/,/g, '');
    return parseFloat(number);
};
// Format a float with commas in the right spots
String.prototype.format_commas = function () {
    var number = this.toString().split('.');
    number[0] = number[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    number = number.join('.');
    return number.toFixed(2);
};

Number.prototype.format_commas = function () {
    var number = this.toFixed(2).split('.');
    number[0] = number[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    number = number.join('.');
    return number;
};

/**
 * jQuery.fn.sortElements
 * --------------
 * @author James Padolsey (http://james.padolsey.com)
 * @version 0.11
 * @updated 18-MAR-2010
 * --------------
 * @param Function comparator:
 *   Exactly the same behaviour as [1,2,3].sort(comparator)
 *
 * @param Function getSortable
 *   A function that should return the element that is
 *   to be sorted. The comparator will run on the
 *   current collection, but you may want the actual
 *   resulting sort to occur on a parent or another
 *   associated element.
 *
 *   E.g. $('td').sortElements(comparator, function(){
 *      return this.parentNode;
 *   })
 *
 *   The <td>'s parent (<tr>) will be sorted instead
 *   of the <td> itself.
 */
jQuery.fn.sortElements = (function () {
    var sort = [].sort;

    return function (comparator, getSortable) {
        getSortable =
            getSortable ||
            function () {
                return this;
            };

        var placements = this.map(function () {
            var sortElement = getSortable.call(this),
                parentNode = sortElement.parentNode,
                // Since the element itself will change position, we have
                // to have some way of storing it's original position in
                // the DOM. The easiest way is to have a 'flag' node:
                nextSibling = parentNode.insertBefore(document.createTextNode(''), sortElement.nextSibling);

            return function () {
                if (parentNode === this) {
                    throw new Error("You can't sort elements if any one is a descendant of another.");
                }

                // Insert before flag:
                parentNode.insertBefore(this, nextSibling);
                // Remove flag:
                parentNode.removeChild(nextSibling);
            };
        });

        return sort.call(this, comparator).each(function (i) {
            placements[i].call(getSortable.call(this));
        });
    };
})();
